import type { ArticleSection, CoverContent, CtaContent } from '../types/advertorial'

export const metaPixel = {
  id: '2243850073137099',
  pageViewEvent: 'PageViewadvertorial'
}

export const cover: CoverContent = {
  mast: 'THE MASCULINE FAITH REVIEW',
  tag: 'EDICIÓN ESPECIAL — SALUD & FE',
  kicker: 'Investigación Especial · Neuro-Teología',
  headline: {
    before: 'La Razón Biológica por la que el ',
    accent: '95%',
    after: ' de los Hombres Cristianos Fallan en su Lucha por la Pureza',
    paren: '(Y por qué no es una falta de fe)'
  },
  subheadline:
    'Una nueva investigación sobre “Neuro-Teología” revela cómo la pornografía moderna “secuestra” el cerebro masculino, haciendo que las disciplinas espirituales tradicionales sean casi imposibles de mantener.',
  byline: [
    'POR EL EQUIPO DE INVESTIGACIÓN NEURO-PUREZA',
    '8 MIN DE LECTURA',
    'EL MITO DE LA FUERZA DE VOLUNTAD'
  ],
  scrollCue: 'DESLIZA PARA LEER EL REPORTAJE',
  image: {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/4c3efda8-3342-41d2-aa5a-2f375ed63b2d.jpg',
    alt: 'Hombre sentado a solas en una habitación oscura, con el rostro iluminado por el brillo azul de la pantalla de su teléfono'
  }
}

export const sections: ArticleSection[] = [
  {
    id: 'ciclo-domingo',
    index: '01',
    title: 'El Ciclo del Domingo por la Noche',
    blocks: [
      {
        type: 'p',
        dropCap: true,
        lead: true,
        text: 'Para la mayoría de los hombres cristianos, la historia es la misma. El domingo por la mañana, están en la iglesia, con el corazón lleno, prometiendo honestamente que “esta vez será diferente”.'
      },
      {
        type: 'figure',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/0ac918f9-2943-4ac6-a4f6-70d976b5573c.jpg',
        alt: 'Congregación de hombres en la iglesia un domingo por la mañana, con haces de luz entrando por las ventanas',
        caption:
          'Domingo, 10:00 a.m. — La resolución se siente inquebrantable. Cuarenta y ocho horas después, el cerebro cuenta otra historia.'
      },
      {
        type: 'p',
        text: 'Pero llega el martes por la noche. Estás cansado, estresado o simplemente solo. En un microsegundo, tu resolución se desvanece. El brillo azul de la pantalla te atrapa y, minutos después, te encuentras en ese pozo familiar de náusea, culpa y una pregunta que te carcome el alma:'
      },
      { type: 'quote', text: '“Si realmente amo a Dios, ¿por qué no puedo parar?”' }
    ]
  },
  {
    id: 'cableado',
    index: '02',
    title: 'No es un Problema de Fe, es un Problema de “Cableado”',
    blocks: [
      {
        type: 'p',
        text: 'Durante décadas, la respuesta de la iglesia ha sido: “Ora más, ayuna más, ten más fe”. Y aunque esas cosas son fundamentales, para el hombre atrapado en el consumo compulsivo, es como pedirle a alguien con una pierna rota que corra un maratón solo con “fe”.'
      },
      {
        type: 'p',
        text: 'Investigaciones recientes en Neuro-Teología han descubierto que la pornografía moderna actúa como una “super-estimulación”. Cuando un hombre consume este contenido, su cerebro libera una cantidad de dopamina —el químico del placer y la recompensa— que supera por mil cualquier experiencia natural.'
      },
      {
        type: 'stat',
        value: '×1000',
        label: 'Descarga de dopamina',
        detail:
          'La super-estimulación digital desborda un sistema de recompensa que fue diseñado para experiencias naturales.'
      },
      { type: 'banner', text: 'El resultado es devastador: el secuestro del lóbulo frontal.' },
      {
        type: 'figure',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/0898137d-83fc-4474-8723-c54f507a7489.jpg',
        alt: 'Modelo anatómico de un cerebro humano en la oscuridad con el lóbulo frontal iluminado en ámbar',
        caption:
          'El lóbulo frontal: el centro de mando moral. Bajo sobrecarga química, deja de responder justo cuando más lo necesitas.'
      },
      {
        type: 'p',
        text: 'Tu lóbulo frontal es la parte del cerebro que toma decisiones morales y controla los impulsos. La exposición constante a la dopamina artificial hace que esta área se “apague” literalmente en el momento de la tentación. No es que no quieras obedecer a Dios; es que el centro de control de tu cerebro ha sido desconectado por una sobrecarga química.'
      }
    ]
  },
  {
    id: 'trampa-streaks',
    index: '03',
    title: 'La Trampa de los “Streaks” (Rachas de Días)',
    blocks: [
      {
        type: 'p',
        text: 'La mayoría de las soluciones actuales se enfocan en “contar días”. Pero la ciencia nos dice que enfocarse en “no hacer algo” solo mantiene ese “algo” en el centro de tu atención, fortaleciendo el camino neuronal del deseo.'
      },
      {
        type: 'figure',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/ca17f03a-494b-417e-8e3c-d5152fad3ea5.jpg',
        alt: 'Mano marcando con tinta negra los días tachados de un calendario de pared',
        caption: 'Contar días convierte la tentación en el centro de tu atención. Cada casilla la refuerza.'
      },
      {
        type: 'p',
        text: 'Es por eso que, cuando un hombre que lleva 10 días limpio cae, siente que ha vuelto a “cero”. Esta mentalidad de fracaso dispara el cortisol —la hormona del estrés—, lo cual… adivinaste… te empuja a buscar alivio de nuevo en la pantalla.'
      },
      {
        type: 'cycle',
        steps: [
          { label: 'Racha', text: 'Cuentas los días y vigilas la tentación sin parar.' },
          { label: 'Caída', text: 'Un momento de agotamiento reinicia el contador a cero.' },
          { label: 'Cortisol', text: 'La vergüenza dispara la hormona del estrés.' },
          { label: 'Alivio', text: 'El cerebro exige la única salida que conoce: la pantalla.' }
        ]
      },
      { type: 'banner', text: 'Es un círculo vicioso diseñado para que pierdas.' }
    ]
  },
  {
    id: 'renovacion',
    index: '04',
    title: 'La Renovación de la Mente es Biológica',
    blocks: [
      {
        type: 'verse',
        text: '“Transformaos mediante la renovación de vuestro entendimiento.”',
        reference: 'Romanos 12:2'
      },
      {
        type: 'p',
        text: 'Hoy sabemos que eso que la Escritura ordenó hace dos mil años tiene un nombre científico: Neuroplasticidad. La libertad real no ocurre cuando “luchas contra el pecado” con los dientes apretados, sino cuando aprendes a re-cablear tu cerebro para que los receptores de dopamina sanen.'
      },
      {
        type: 'figure',
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/2ff31771-68de-4828-b26b-d30f9102c831.jpg',
        alt: 'Hombre de pie frente a una ventana al amanecer, con la luz dorada iluminando la mitad de su rostro',
        caption: 'Cuando la biología sana, la voluntad regresa. Dejas de pelear y empiezas a gobernar.'
      },
      {
        type: 'p',
        text: 'Cuando sanas tu biología, tu voluntad regresa. Dejas de pelear contra un gigante y empiezas a operar desde una posición de autoridad. Los hombres que han aplicado este enfoque de “Neuro-Pureza” reportan algo increíble: el deseo simplemente se apaga.'
      },
      {
        type: 'p',
        text: 'Ya no tienen que luchar para no ver; simplemente dejan de tener la necesidad de buscar alivio en una imagen.'
      }
    ]
  },
  {
    id: 'identidad',
    index: '05',
    title: 'El Camino Hacia la Recuperación de tu Identidad',
    blocks: [
      {
        type: 'p',
        text: 'Si estás cansado de los filtros que no funcionan, de las promesas rotas y de la neblina mental que te impide ser el líder que tu familia merece, debes entender que hay un camino diferente. Un camino que une la verdad eterna de la Biblia con los descubrimientos más avanzados de la neurociencia.'
      },
      {
        type: 'p',
        text: 'Un grupo de expertos y ex-adictos ha sistematizado este proceso en un método llamado “Neuro-Pureza”. No es una racha de 21 días; es un protocolo de re-configuración mental diseñado para que recuperes tu mente, tu matrimonio y tu hombría en 30 días o menos.'
      }
    ]
  }
]

export const cta: CtaContent = {
  eyebrow: 'El Método',
  title: 'Neuro-Pureza: 30 días para recuperar el mando de tu mente',
  paragraphs: [
    'Un protocolo de re-configuración mental que une la verdad eterna de la Biblia con la neurociencia de la recuperación de la dopamina.'
  ],
  bullets: [
    'No cuentas días: sanas los receptores que disparan el impulso.',
    'Reactiva el lóbulo frontal, tu centro de decisión moral.',
    'Diseñado para hombres cristianos, no para clínicas seculares.'
  ],
  buttonLabel: 'DESCUBRE EL MÉTODO DE NEURO-PUREZA AQUÍ',
  reassurance: 'Acceso inmediato · Basado en Escritura y neurociencia · Confidencial',
  href: 'https://neuro.rutinasimple.com/spp'
}

export const stickyCta = {
  label: 'Método Neuro-Pureza',
  hint: 'Recupera tu mente en 30 días',
  buttonLabel: 'VER EL MÉTODO'
}
